import { useSelector } from 'react-redux';

export default () => {
    const currentAliasId = useSelector(state => state.application.aliasId);
    const showroomAliasID = 4;

    return showroomAliasID === currentAliasId;
};
